import React, {useState} from 'react';
import Section from '../../Components/Containers/Section';
import { useNotifications } from '../../Data/Admin';
import Loading from '../../Components/Loading';
import DateTime from '../../Components/Formatting/DateTime';
import Button from '../../Components/Button/Button';
import { Link } from 'react-router-dom';
import Dropdown from '../../Components/Dropdown';

const Notifications = () => {
    const {notifications, markAllSeen, isLoading} = useNotifications();
    const [show, setShow] = useState('New');

    return <Section title="Notifications"
        options={['New', 'All']}
        optionsVal={show}
        optionsCallback={setShow}
        button={<Button theme="light" icon="Check" zeroMargin onClick={markAllSeen} loading={isLoading} />}
    >
        {notifications ? <Inner {...{notifications, show}} /> : <Loading center />}
    </Section>
}

const Inner = ({notifications, show}) => {
    return <ul className="divide-y divide-gray-200">
        {notifications.map((notification, i) => {
            if (notification.status !== 'Active' && show === 'New') {
                return null;
            }

            return <li key={i} className="py-2 flex flex-row justify-between">
                <Link to={`/admin/businesses?search=${notification.entityId}`} className="flex flex-col gap-y-1">
                    <p className="font-bold">{getTitle(notification.entityModel)}</p>
                    <p>{notification.message}</p>
                    <p className="text-xs text-muted"><DateTime date={notification.updatedAt} /></p>
                </Link>
                <div>
                    <Dropdown options={[]} disabled />
                </div>
            </li>
        })}

        {show === 'New' && notifications.filter(n => n.status === 'Active').length === 0 && <li className="py-2 text-center text-muted">
            No new notifications
        </li>}
    </ul>
}

const getTitle = (model) => {
    switch (model) {
        case 'Businesses/Business':
            return 'Business';

        default:
            return model;
    }
}


export default Notifications;
